import {
  CUSTOM_REQUEST,
  CUSTOM_REQUEST_CLEAR_DATA,
  CUSTOM_REQUEST_ERROR,
  CUSTOM_REQUEST_SUCCESS,
} from "./actionTypes";

const initialState = {
  dataCustomRequest: {},
  loadingCustomRequest: {},
  errorCustomRequest: {},
  pagingInfo: {},
};

const CustomRequest = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOM_REQUEST: {
      const key = action.payload.requestKey;
      state = {
        ...state,
        loadingCustomRequest: { ...state.loadingCustomRequest, [key]: true },
        errorCustomRequest: { ...state.errorCustomRequest, [key]: null },
      };
      break;
    }
    case CUSTOM_REQUEST_SUCCESS: {
      const key = action.requestKey;
      state = {
        ...state,
        loadingCustomRequest: { ...state.loadingCustomRequest, [key]: false },
        dataCustomRequest: {
          ...state.dataCustomRequest,
          [key]: action.payload.data ?? action.payload,
        },
        pagingInfo: {
          ...state.pagingInfo,
          [key]: action.payload.pagingInfo ?? null,
        },
      };
      break;
    }
    case CUSTOM_REQUEST_ERROR: {
      const key = action.requestKey;
      state = {
        ...state,
        loadingCustomRequest: { ...state.loadingCustomRequest, [key]: false },
        errorCustomRequest: {
          ...state.errorCustomRequest,
          [key]: action.payload,
        },
      };
      break;
    }
    case CUSTOM_REQUEST_CLEAR_DATA: {
      const key = action.requestKey;
      const { [key]: _d, ...dataRest } = state.dataCustomRequest;
      const { [key]: _l, ...loadRest } = state.loadingCustomRequest;
      const { [key]: _e, ...errRest } = state.errorCustomRequest;
      const { [key]: _p, ...pagingRest } = state.pagingInfo;
      state = {
        dataCustomRequest: dataRest,
        loadingCustomRequest: loadRest,
        errorCustomRequest: errRest,
        pagingInfo: pagingRest,
      };
      break;
    }
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CustomRequest;
